/* eslint-disable no-console */
import { TAO_KOE } from './../libs';
import MomenteDetailTemplate from './templates/moment.tpl.html';

const Moments = {};
const fetchSingleMoment = function( postId ) {
	const url = '/dispatch/momente/getSingleMoment';

	const args = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify( { id: postId } ),
	};

	if ( 'undefined' !== typeof Moments[ postId ] ) {
		return Promise.resolve( Moments[ postId ] );
	}

	return fetch( url, args )
		.then( ( response ) => {
			if ( ! response.ok ) {
				throw Error( response.statusText );
			}
			return response;
		} )
		.then( ( response ) => response.json() )
		.then( ( response ) => {
			Moments[ postId ] = response;
			return response;
		} )
		.catch( ( error ) => {
			console.error( error );
			throw 'Der Moment konnte nicht geladen werden!';
		} );
};

const getSingleMoment = function( postId ) {
	const popup = document.getElementById( 'popup_moment' );

	popup.querySelector( '.mdl_popup__body' ).innerHTML = '';
	popup.classList.add( 'en_is_loading' );

	fetchSingleMoment( postId )
		.then( ( data ) => {
			data.isForm = false;
			return updatePopup( data );
		} )
		.catch( ( error ) => {
			popup.querySelector( '.mdl_popup__body' ).innerHTML =
			`<div class="notification error en_spacer_top">
                <p>${ error }</p>
            </div>`;
			delete Moments[ postId ];
		} )
		.finally( () => {
			document.getElementById( 'popup_moment' ).classList.remove( 'en_is_loading' );
		} );
};

const updatePopup = function( data ) {
	try {
		const targetDiv = document.getElementById( 'popup_moment' );

		const renderedContent = MomenteDetailTemplate( data );
		targetDiv.querySelector( '.mdl_popup__body' ).innerHTML = renderedContent;

		const promises = [];
		return Promise.all( promises );
	} catch ( error ) {
		throw 'Der Moment konnte nicht dargestellt werden!';
	}
};

TAO_KOE.ready( 'momente.js', function() {
	const popupTriggerEls = document.querySelectorAll( '.mdl_moments__entry.en_js_open_popup' );
	popupTriggerEls.forEach( ( popupTriggerEl ) => {
		popupTriggerEl.addEventListener( 'click', () => {
			if ( popupTriggerEl.hasAttribute( 'data-moment-id' ) ) {
				getSingleMoment( popupTriggerEl.getAttribute( 'data-moment-id' ) );
			}
		} );
	} );
} );
